module.exports = __webpack_public_path__ + "img/fav.4d1b2607.svg";